import { nortadaLogger } from '../../../../../../common/logger';

import { EventsType } from './interfaces';
import PresentEvents from './presentEvents';
import ExpiredEvents from './expiredEvents';

interface Props {
  events: EventsType;
}

const Events = ({ events }: Props) => {
  switch (events.type) {
    case 'PRESENT': {
      return <PresentEvents events={events} />;
    }
    case 'EXPIRED': {
      return <ExpiredEvents />;
    }
    default: {
      nortadaLogger.error(`Event type is not supported`);
      return null;
    }
  }
};

export default Events;
